var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"above-overlay"},[_c('div',{staticClass:"pull-left"},[_c('div',{staticClass:"card card-default"},[_c('div',{staticClass:"card-body"},[_c('div',{},[_c('button',{staticClass:"btn btn-info pull-left",attrs:{"type":"button"},on:{"click":function($event){return _vm.goToPortal()}}},[_vm._v(_vm._s(_vm.portalDetails.name))])])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }